import { render, staticRenderFns } from "./QuantityButton.vue?vue&type=template&id=18510fa8&scoped=true&"
import script from "./QuantityButton.vue?vue&type=script&lang=js&"
export * from "./QuantityButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18510fa8",
  null
  
)

export default component.exports